import { useState, ReactNode } from 'react'

import { useSpring, animated as a } from 'react-spring'

import SVGIcon from '~/components/Icons/svgs/SVGIcon'
import ArrowCircleIcon from '~/components/Icons/svgs/ArrowCircleIcon'
import { IconName } from '~/components/Icons/types'
import ToolTip from '~/components/QuestPanel/components/ToolTip'
import { Quest } from '~/components/QuestPanel/type'

interface props {
  title: string
  bgPadding?: string
  h4ClassName?: string
  iconName?: IconName
  children: ReactNode
  className?: string
  bgColor: string
  txtColor: string
  showExclamation?: boolean
  isCollection?: boolean
  onRetakeQuizClick?: () => void
  quests?: Quest[]
}

export default function QuestBox({
  title,
  bgPadding,
  h4ClassName,
  className,
  children,
  bgColor,
  txtColor,
  showExclamation,
  onRetakeQuizClick,
  quests,
}: props): React.ReactElement {
  const [toggleTooltip, setToggleTooltip] = useState(false)
  const bgClassNames = ` ${bgColor} ${txtColor} relative z-20 rounded gap-4 lg:mx-0`
  const WrapperClassNames = `relative w-full isolate ${className}`
  const titleClassNames = 'font-semibold text-lg'
  const fadeIn = useSpring({
    from: { opacity: 0, y: -20 },
    to: { opacity: 1, y: 0 },
  })

  return (
    <>
      {toggleTooltip && <ToolTip />}
      <a.div className={WrapperClassNames} style={{ ...fadeIn }}>
        <div className={`${bgClassNames} ${bgPadding ? bgPadding : ' px-3 py-2 sm:px-4'}`}>
          <header className="flex gap-5">
            <h4 className={`${titleClassNames} ${h4ClassName ? h4ClassName : ''}`}>{title}</h4>
            {showExclamation && <h4 className="ml-auto font-bold text-lg -mt-1 animate-bounce">!</h4>}

            {quests && quests.length > 0 && (
              <div className="flex ml-auto gap-3">
                <div
                  className="flex items-center cursor-pointer transition md:hover:scale-110"
                  onClick={onRetakeQuizClick}
                >
                  <SVGIcon icon={ArrowCircleIcon} pathClassName="text-white" size={22} />
                </div>
                <span
                  className={`text-purple bg-white md:hover:bg-purple-gdark md:hover:text-white flex ml-auto items-center 
                  justify-center self-center rounded-full w-6 h-6 text-md font-semibold transition cursor-pointer md:hover:scale-110`}
                  onClick={() => setToggleTooltip(!toggleTooltip)}
                >
                  i
                </span>
              </div>
            )}
          </header>
          {children}
        </div>
      </a.div>
    </>
  )
}
